module.exports = __webpack_public_path__ + "img/current-integral.10ed6813.png";